<template>
    <div class="container">
        <el-page-header @back="$router.back()" content="机构办赛的赛事审核"></el-page-header>
        <div class="content">
            <el-alert
                title="审核不通过原因："
                :description="(editInfo.AuditReason || '')"
                type="warning"
                effect="dark"
                show-icon
                :closable="false"
                style="margin-bottom:30px"
                v-if="editInfo && [5, 6].includes(editInfo.LeagueNowStatus)">
            </el-alert>
            <el-descriptions title="赛事基本信息" :column="1" :labelStyle="{'width':'100px','justify-content': 'end','padding-right':'12px','margin-right':'0','box-sizing':'border-box'}">
                <el-descriptions-item label="所属主赛事">{{editInfo.MainLeagueName || '-'}}</el-descriptions-item>
                <el-descriptions-item label="运动项目">{{editInfo.EventsName}}</el-descriptions-item>
                <el-descriptions-item label="赛季名称">{{editInfo.SeasonName}}</el-descriptions-item>
                <el-descriptions-item label="赛事全称">{{editInfo.LeagueFullName}}</el-descriptions-item>
                <el-descriptions-item label="赛事简称">{{editInfo.LeagueShortName || '-'}}</el-descriptions-item>
                <template v-if="editInfo.MastersJoined">
                    <el-descriptions-item label="赛事等级">{{editInfo.CurrentCertificateLevel}}级</el-descriptions-item>
                    <el-descriptions-item label="大师分类型">
                        <el-select v-model="MastersScoreType" style="width:100px">
                            <el-option :value="1">金分</el-option>
                            <el-option :value="2">银分</el-option>
                            <el-option :value="3">红分</el-option>
                        </el-select>
                    </el-descriptions-item>
                </template>
                <el-descriptions-item label="比赛形式">{{editInfo.IsOnline ? '线上赛' : '线下赛'}}</el-descriptions-item>
                <el-descriptions-item label="比赛平台url" v-if="editInfo.IsOnline">{{editInfo.LeagueSite || '-'}}</el-descriptions-item>
                <el-descriptions-item label="赛事LOGO">
                    <img :src="editInfo.LogoUrl" style="width: 100px;height: 100px;object-fit: cover;" v-if="editInfo.LogoUrl" @click="lookImage(editInfo.LogoUrl)"/>
                    <span v-else>无</span>
                </el-descriptions-item>
                <el-descriptions-item label="封面图片">
                    <img :src="editInfo.CoverUrl" style="height: 100px;" v-if="editInfo.CoverUrl" @click="lookImage(editInfo.CoverUrl)"/>
                    <span v-else>无</span>
                </el-descriptions-item>
                <el-descriptions-item label="特殊状态">
                    <span :style="editInfo.AbnormalStatus > 0 ? 'color:red' : ''">{{['无（正常）','赛事取消','赛事延期','赛事中断'][editInfo.AbnormalStatus]}}</span>
                </el-descriptions-item>
                <el-descriptions-item label="公告标题" v-if="editInfo.AbnormalStatus > 0 && editInfo.BulletinUrl">
                    <span>{{editInfo.BulletinTitle}}<a :href="editInfo.BulletinUrl" target="_blank">点击查看</a></span>
                </el-descriptions-item>
                <el-descriptions-item label="比赛时间">
                    <span v-if="editInfo.GameTime">{{formatDate(editInfo.GameTime.BeginTime)}} ~ {{formatDate(editInfo.GameTime.EndTime)}}</span>
                    <span v-else>未定</span>
                </el-descriptions-item>
                <el-descriptions-item label="比赛平台" v-if="editInfo.IsOnline">-</el-descriptions-item>
                <el-descriptions-item label="比赛地点">
                    <div style="width: 100%;max-width: 700px;display:flex;flex-wrap: wrap;">
                        <el-tag
                            v-for="(item,index) in editInfo.GamePlace" :key="index"
                            effect="plain" size="small"
                            style="margin-right:10px;margin-bottom:5px"
                        >
                            {{item.RegionName}}
                        </el-tag>
                    </div>
                </el-descriptions-item>
                <el-descriptions-item :label="item.Kind" v-for="(item,index) in Units" :key="index" >
                    <div style="width: 100%;max-width: 700px;display:flex;flex-wrap: wrap;">
                        <el-tag
                            v-for="(unitItem,unitIndex) in item.Units" :key="unitIndex"
                            effect="plain" size="small"
                            style="margin-right:10px;margin-bottom:5px"
                        >
                            {{unitItem}}
                        </el-tag>
                    </div>
                </el-descriptions-item>
                <el-descriptions-item label="竞赛规程">
                    <div style="width: 100%">
                        <Editor :value="editInfo.Comment" v-if="editInfo.Comment" disabled></Editor>
                        <div class="image_list" v-if="editInfo.PictureFiles">
                            <div class="img" v-for="item,index in editInfo.PictureFiles" :key="index">
                                <img :src="item.FileUrl" @click="lookImage(item.FileUrl, editInfo.PictureFiles.map(item=>item.FileUrl))">
                            </div>
                        </div>
                        <div class="file_list" v-if="editInfo.DocFiles">
                            <el-card class="file_container" title="点击下载文档附件" v-for="item,index in handleDocFiles" :key="index">
                                <div class="file" @click="downloadFile(item)">
                                    <div class="icon" :class="item.className"></div>
                                    <div class="file_info">
                                        <div class="file_name">{{item.name}}</div>
                                        <div class="file_size">{{item.size}}</div>
                                    </div>
                                </div>
                            </el-card>
                        </div>
                    </div>
                </el-descriptions-item>
            </el-descriptions>
            <el-divider></el-divider>
            <el-descriptions title="赛事分组信息"></el-descriptions>
            <el-card shadow="never" v-for="(item,index) in handleEventsGroupList" :key="index" class="group_card">
                <el-descriptions title="" :column="1" :labelStyle="{'width':'100px','justify-content': 'end','padding-right':'12px','margin-right':'0','box-sizing':'border-box'}">
                    <el-descriptions-item label="比赛项目">{{item.Name}}</el-descriptions-item>
                    <el-descriptions-item label="组别">
                        <div style="width: 100%;display:flex;flex-wrap: wrap;">
                            <el-tag
                                v-for="(groupItem,groupIndex) in item.groups" :key="groupIndex"
                                effect="plain" size="small"
                                style="margin-right:10px;margin-bottom:5px"
                            >
                                {{groupItem.GroupName}}（{{getGroupTypeText(groupItem)}}）
                            </el-tag>
                        </div>
                    </el-descriptions-item>
                </el-descriptions>
            </el-card>
            <template  v-if="editInfo.LeagueNowStatus == 5">
                <el-divider></el-divider>
                <el-row style="margin:30px 0 20px 100px">
                    <el-button type="primary" style="width:120px" @click="aduit(true)">通过审核</el-button>
                    <el-button type="danger" style="width:120px" @click="aduit(false)">不通过审核</el-button>
                </el-row>
            </template>
        </div>
        <el-image ref="imagePreview" class="image_preview"
            :src="imageUrl" 
            :preview-src-list="imagePreviews">
        </el-image>
    </div>
</template>

<script>
import Editor from '@/components/Editor';
import { toQueryString } from '@/assets/js/util'
import {
    GetSubleagueDetail
} from '@/newApi';
import {
    formatFileSize
} from '@/common/tools';
export default {
    name: 'ContestDetail',
    components: { 
        Editor
    },
    data() {
        return {
            token: this.$cookies.get('token'),
            subLeagueId: 0,
            editInfo: {},
            MastersScoreType: '',
            imagePreviews:[],
            imageUrl: ''
        }
    },
    created(){
        let subLeagueId = +(this.$route.params.leagueId || 0);
        this.subLeagueId = subLeagueId;
        this.getDetail();
    },
    computed: {
        groupTypes(){
            return [
                { value: 1, label: '个人' },
                { value: 2, label: '团体' },
                { value: 3, label: '双人组合' }
            ]
        },
        Units() {
            if(!this.editInfo.AllUnits) return;
            let units = this.editInfo.AllUnits;
			return units;
        },
        handleDocFiles(){
            if(!this.editInfo.DocFiles) return;
            return this.editInfo.DocFiles.map(item=>{
                let name = item.FileName,
                    url = item.FileUrl;
                let type = name.substr(name.lastIndexOf('.')).substr(1).toLowerCase();
                if(!type){
                    type = url.substr(url.lastIndexOf('.')).substr(1).toLowerCase();
                }
                let className = type;
                if(['docx', 'doc'].includes(type)){
                    className = 'word';
                }else if(['xlsx', 'xls'].includes(type)){
                    className = 'excel';
                }else if(['pptx', 'ppt'].includes(type)){
                    className = 'ppt';
                }else if(['pdf'].includes(type)){
                    className = 'pdf';
                }
                return {
                    url,
                    name,
                    size: formatFileSize(item.FileSize),
                    className
                }
            })
        },
        groups(){
            return this.editInfo.GroupList || [];
        },
        handleEventsGroupList(){
            let eventsList = [];
            this.groups.forEach(groupItem=>{
                let obj = eventsList.find(item=>item.Id == groupItem.EventsId);
                if(obj){
                    obj.groups.push(groupItem);
                }else{
                    eventsList.push({
                        Id: groupItem.EventsId,
                        Name: groupItem.EventsName,
                        groups: [groupItem]
                    })
                }
            })
            return eventsList;
        }
    },
    methods: {
        formatDate(value){
            if(!value) return '';
            return new Date(value).format('yyyy-MM-dd HH:mm');
        },
        getGroupTypeText(groupItem){
            let groupTypes = this.groupTypes;
            return (groupTypes.find(item=>item.value == groupItem.GroupType) || {}).label + (groupItem.IsHonored ? '，嘉宾' : '');
        },
        //获取赛事详情
        getDetail () {
            GetSubleagueDetail({
                SubLeagueId: this.subLeagueId
            }).then(data=>{
                if(data.Code == 0){
                    let editInfo = data.EditInfo;
                    this.editInfo = editInfo;
                    if(editInfo.MastersJoined){
                        if(editInfo.MastersScoreType){
                            this.MastersScoreType = editInfo.MastersScoreType;
                        }else{
                            if(['A','B'].includes(editInfo.CurrentCertificateLevel)){
                                this.MastersScoreType = 1;
                            }else if(['C','D'].includes(editInfo.CurrentCertificateLevel)){
                                this.MastersScoreType = 2;
                            }else{
                                this.MastersScoreType = 3;
                            }
                        }
                    }
                }
            })
        },
        aduit(isPass){
            if(isPass){
                if(this.editInfo.MastersJoined && !this.MastersScoreType){
                    this.$message.error('请选择大师分类型');
                    return;
                }
                this.$confirm('确认审核通过？', '审核通过', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消'
                }).then(() => {
                    this.aduitApi();
                })
            }else{
                this.$prompt('审核不通过的原因：', '审核不通过', {
                    confirmButtonText: '审核不通过',
                    cancelButtonText: '取消',
                    inputType: 'textarea',
                    inputValue: this.editInfo.AuditReason || '',
                    inputValidator:(value)=>{
                        if(!value){
                            return '请输入审核不通过的原因';
                        }
                    }
                }).then(({ value }) => {
                    this.aduitApi(value);
                })
            }
        },
        aduitApi(reason = ''){
            let loading = this.$loading({
                lock: true,
                text: '提交中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            this.$axios.post('Match/Entrance', toQueryString({
                action: 'Upt_league_status',
                type: 3,
                league_id: this.subLeagueId,
                enroll_type: 0,
                user_token: this.token,
                audit_reason: reason,
                masters_score_type: this.MastersScoreType
            })).then((res) => {
                loading.close();
                let data = res.data;
                if(data.code == -200) {
                    this.$alert('登录失效，请刷新重新登录', '提示', {
                        confirmButtonText: '刷新'
                    }).then(() => {
                        this.clearCookie()
                        this.refresh()
                    })
                } else if(data.code == 1) {
                    this.$alert('提交成功', '提示', {
                        confirmButtonText: '返回列表'
                    }).then(() => {
                        this.$router.push('/match/pass')
                    })
                } else {
                    this.$message.error(data.message);
                }
            }).catch(() => {
                loading.close();
                this.$message.error('网络异常');
            })
        },
        lookImage(url, urls){
            if(!url) return;
            if(!urls){
                urls = [url];
            }
            this.imagePreviews = urls;
            this.imageUrl = url;
            this.$refs.imagePreview.showViewer = true;
        },
        downloadFile(data){
            this.$file.download(data.url, data.name);
        }
    }
}
</script>
<style scoped>
@import "~@/assets/css/clear-el.css";
    .group_card{
        width:100%;
        max-width:700px;
        box-sizing: border-box;
        margin-bottom:20px
    }
    .group_card::v-deep .el-card__body{
        padding: 20px 10px 0 0px !important;
    }
.el-descriptions::v-deep .el-descriptions-item__content{
    width: 100%;
}
.el-descriptions::v-deep .el-descriptions-item__content .editor{
    width: 100%;
}
</style>
